import NotAuthMobileNav from '@/components/shared/TopNav/NotAuthMobileNav';
import { Button } from '@/components/ui/button';
import { useEffect, useState } from 'react';
import { DownloadView } from './DownloadView';
import { Icons } from '@/components/shared/icons';
import MobileMenu from '@/components/shared/MobileMenu';
import useIsPWA from '@/hooks/utilities/useIsPWA';
import usePWAInstallPrompt from '@/hooks/utilities/usePWAInstallPrompt';
import SlidingModal from '../SlidingModal';
import { useDetectPlatform } from '@/hooks/utilities/useDetectPlatform';
import { useRouter } from 'next/router';
enum OnboardStates {
  Default = 'default',
  Web = 'web',
  Download = 'donwload',
}
export default function OnboardingLayout({
  runAuthFlow
}) {
  const [currentState, setCurrentState] = useState(OnboardStates.Default);
  const isPWA = useIsPWA();
  const platform = useDetectPlatform();
  const router = useRouter();
  const showContinue = router?.query?.showContinue === 'true';
  useEffect(() => {
    if (isPWA) {
      setCurrentState(OnboardStates.Web);
    }
  }, [isPWA]);
  useEffect(() => {
    console.log('User platform:', platform);
    // You can add conditional logic based on the platform here
  }, [platform]);
  const {
    isSupported,
    promptInstall
  } = usePWAInstallPrompt();
  return <div data-sentry-component="OnboardingLayout" data-sentry-source-file="OnboardingLayout.tsx">
      <div className='w-full min-h-screen p-2 flex flex-col justify-center items-center relative onboard-mobile'>
        <div className={`flex-grow w-full onboard-box my-2 rounded-md ${currentState === OnboardStates.Web && 'mt-2'}`}>
          <div className='z-10 flex flex-col inner-onboard'>
            <>
              <div className='ta-c items-center justify-start text-genius-pink space-x-2 mt-10'>
                <img src='/static/genius.svg' height={36} width={36} alt='logo' />
                <div className='mt-12 text-purple-300 text-lg z-20'>Welcome</div>
              </div>
              <div className='text-center text-6xl font-medium tracking-tighter text-genius-cream lg:mt-28 mt-12'>
                Genius
              </div>
              <div className='flex flex-col w-full px-2 mt-4 lg:mt-0'>
                <div className='flex flex-col items-center justify-center lg:px-4'>
                  {currentState === OnboardStates.Default ? <div className='w-full absolute bottom-6 px-2'>
                      <Button className='w-full mt-2 lg:w-3/4 rounded-full bg-genius-pink text-genius-indigo transition-all duration-300 h-12' onClick={async () => {
                    if (isSupported || platform === 'android') {
                      const result = await promptInstall();
                      console.log('result---------->', result);
                      if (!result) {
                        setCurrentState(OnboardStates.Download);
                      }
                    } else {
                      setCurrentState(OnboardStates.Download);
                    }
                  }}>
                        Download App
                      </Button>

                      <Button variant='purple' className=' w-full mt-2 rounded-full lg:w-3/4 font-normal text-fuchsia-100 h-12 ' onClick={() => setCurrentState(OnboardStates.Web)}>
                        Continue Here
                      </Button>
                    </div> : currentState === OnboardStates.Web ? <>
                      <NotAuthMobileNav />
                      <div className='w-full absolute bottom-6 px-2'>
                        <Button className='w-full mt-2 lg:w-3/4 rounded-full bg-genius-pink text-genius-indigo transition-all duration-300 h-12' onClick={() => runAuthFlow('genius-google')}>
                          <img src='/static/images/google_logo.png' width={16} height={16} alt='google' className='mr-6' />
                          Sign in with Google
                        </Button>
                        <Button className='w-full mt-2 lg:w-3/4 rounded-full bg-genius-pink text-genius-indigo transition-all duration-300 h-12' onClick={() => runAuthFlow('apple')}>
                          <Icons.apple className='mr-6 h-4 w-4' />
                          Sign in with Apple
                        </Button>
                        {/* <AuthButton AuthType={"twitter"} clientsReady={true} onClick={() => AuthButtonHandlers("twitter")} /> */}
                        {/* <p
                          className='ta-c underline text-genius-cream/50 cursor-pointer mt-4 text-xs'
                          onClick={() => setCurrentState(OnboardStates.Default)}
                         >
                          Go Back
                         </p> */}
                      </div>
                      <MobileMenu />
                    </> : ''}
                </div>
                <SlidingModal isOpen={currentState === OnboardStates.Download} onClose={() => setCurrentState(OnboardStates.Default)} data-sentry-element="SlidingModal" data-sentry-source-file="OnboardingLayout.tsx">
                  <DownloadView data-sentry-element="DownloadView" data-sentry-source-file="OnboardingLayout.tsx" />
                </SlidingModal>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>;
}